import { Card, ListGroup, ListGroupItem, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const samples = [
    'CD-3503-00.yml',
    'fwls-pm-ilp-lhu-line-config.yml',
    'fwls-pm-ilp-rhu-line-config.yml',
    'fwls-pm-lhu-line-config.yml',
];

export default function DuctlineList() {
    return (
        <Card>
            <Card.Body>
                <Card.Title>Ductlines</Card.Title>
            </Card.Body>
            <ListGroup className="list-group-flush">
                {samples.map((s, i) => (
                    <ListGroupItem key={i}><Link to={`/Ductlines/samples/lines/${s}`}>{s}</Link></ListGroupItem>
                ))}
            </ListGroup>
            <Card.Body>
                <Button
                    size="sm"
                    href="/ductlines"
                >
                    Import New Ductline
                </Button>
            </Card.Body>
        </Card>
    );
}
